/**
 * Configuración centralizada de la aplicación
 * Actualiza estos valores en un solo lugar para reflejar cambios en toda la app
 */

// Información de la empresa
export const COMPANY_INFO = {
  name: "Geriatría Serena",
  legalName: "Geriatría Serena",
  description: "Servicios de enfermería especializada",
  phone: process.env.REACT_APP_PHONE_NUMBER || "3325456522",
  phoneFormatted: "+52 (33) 2545-6522",
  whatsapp: process.env.REACT_APP_WHATSAPP_NUMBER || "523325456522",
  whatsappWithCountry: "521" + (process.env.REACT_APP_WHATSAPP_NUMBER || "3325456522"),
  email: "geriatriaserena@hotmail.com",
  address: "Lago Ginebra 2732, Patria, CP 45160 Guadalajara, Jalisco",
  addressShort: "Lago Ginebra 2732, Patria, 45160 Zapopan, Jal.",
  website: "www.geriatriaserena.com.mx",
  websiteUrl: "https://geriatriaserena.com",
  foundingYear: "2025",
  lastPolicyUpdate: "17/02/2025",
  mapsUrl: "https://maps.app.goo.gl/M6xRYewe2Uq7HbuR9",
  mapsEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3731.8827182778664!2d-103.37659302529391!3d20.71498659848264!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2f695af254efa3e9%3A0xa01877e279d91a8c!2sGeriatr%C3%ADa%20Serena%20%7C%20Enfermeras%20y%20Cuidadores%20a%20Domicilio!5e0!3m2!1ses!2smx!4v1785433233556!5m2!1ses!2smx",
  latitude: 20.71498659848264,
  longitude: -103.37659302529391
};

// Enlaces de redes sociales
export const SOCIAL_LINKS = {
  facebook: "https://www.facebook.com/profile.php?id=61577136581146",
  instagram: "https://www.instagram.com/geriatriaserena?igsh=eGo4MHJlMWoweHo2",
  youtube: "https://www.youtube.com/@Geriatria-Serena"
};

// Configuración del carrusel/banner
export const BANNER_CONFIG = {
  autoAdvanceInterval: 7000,
  pauseDuration: 10000,
  loadingDelay: 1000,
  animationDuration: 500
};

// Horarios de atención
export const BUSINESS_HOURS = [
  { day: "Lunes - Viernes", time: "24 horas" },
  { day: "Sábados y Domingos", time: "24 horas" },
  { day: "Días festivos", time: "24 horas" }
];

// Opciones de contratación por horas
export const HIRING_OPTIONS = [
  { hours: "6 horas", color: "from-blue-500 to-blue-600" },
  { hours: "8 horas", color: "from-blue-500 to-blue-600" },
  { hours: "12 horas", color: "from-blue-500 to-blue-600" },
  { hours: "24 horas", color: "from-blue-500 to-blue-600" }
];

// Áreas de cobertura
export const COVERAGE_AREAS = [
  "Guadalajara",
  "Zapopan",
  "Tlaquepaque",
  "Tonalá",
  "El Salto",
  "Tlajomulco"
];

// Opciones de alcaldías/municipios para formularios
export const ALCALDIAS_OPTIONS = [
  { value: '', label: 'Selecciona tu alcaldía' },
  { value: 'Guadalajara', label: 'Guadalajara' },
  { value: 'Zapopan', label: 'Zapopan' },
  { value: 'Tlaquepaque', label: 'Tlaquepaque' },
  { value: 'Tonalá', label: 'Tonalá' },
  { value: 'Otro', label: 'Otro' }
];

// Opciones de servicios para formularios
export const SERVICIOS_OPTIONS = [
  { value: '', label: 'Selecciona el servicio' },
  { value: 'Cuidadora', label: 'Cuidadora' },
  { value: 'Auxiliar de Enfermería', label: 'Auxiliar de Enfermería' },
  { value: 'Enfermería General', label: 'Enfermería General' }
];

// Opciones de puestos de trabajo
export const JOB_POSITIONS = [
  { value: '', label: 'Selecciona un puesto' },
  { value: 'Cuidador(a)', label: 'Cuidador(a)' },
  { value: 'Auxiliar de Enfermería', label: 'Auxiliar de Enfermería' },
  { value: 'Enfermero(a) General', label: 'Enfermero(a) General' }
];

// Enlaces de navegación
export const NAV_LINKS = [
  { path: '/', label: 'Inicio' },
  { path: '/about-us', label: 'Quiénes somos' },
  { path: '/services', label: 'Servicios' },
  { path: '/blog', label: 'Blog' },
  { path: '/contact', label: 'Contacto' },
  { path: '/careers', label: 'Carreras' }
];

// Expresiones regulares para validación
export const VALIDATION_PATTERNS = {
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  phone: /^[0-9]{10}$/,
  name: /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]{3,}(?:\s[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]{3,}){1,}$/
};

// Mensajes de WhatsApp predefinidos
export const WHATSAPP_MESSAGES = {
  quote: 'Buenos días, me interesa conocer los planes de atención personalizada de Geriatría Serena para un familiar en Guadalajara.',
  contact: '¡Hola! Me gustaría obtener información sobre los servicios de enfermería geriátrica de élite de Geriatría Serena.',
  info: `¡Hola ${COMPANY_INFO.name}! 

Me interesa conocer con mayor detalle sus servicios de enfermería y cuidadoras especializadas a domicilio en Guadalajara.

En particular, quisiera información sobre:
- Servicios de enfermería geriátrica disponibles
- Perfil y certificaciones del personal
- Planes de atención personalizados
- Cobertura en mi zona

Quedo en espera de su atención.`,
  quoteDetailed: `¡Hola ${COMPANY_INFO.name}! 

Me gustaría solicitar información para diseñar un plan de cuidado personalizado.

Datos de referencia:
- Tipo de servicio requerido: [Enfermero/Cuidadora/Enfermería general]
- Modalidad de atención: [Especificar]
- Zona en Guadalajara: [Especificar]
- Condición y necesidades del paciente: [Descripción breve]
- Fecha estimada de inicio: [Fecha]

Agradezco puedan brindarme orientación al respecto.`,
  serviceInquiry: (serviceName) => 
    `Hola, estoy interesado en conocer más sobre el servicio de ${serviceName.toLowerCase()} para un familiar. ¿Podrían proporcionarme información detallada?`,
  hiringInquiry: (hours) =>
    `¡Hola! Quisiera conocer la disponibilidad y los detalles del plan de atención de ${hours} para un familiar en Guadalajara. Agradezco su orientación.`
};

// Configuración de SEO por defecto
export const DEFAULT_SEO = {
  title: "Geriatría Serena — Enfermería Geriátrica de Élite a Domicilio en Guadalajara",
  description: "Servicio exclusivo de enfermería geriátrica a domicilio en Guadalajara. Personal certificado con estándares hospitalarios premium, planes de cuidado VIP personalizados y supervisión médica continua.",
  keywords: "enfermería geriátrica élite guadalajara, cuidadoras especializadas certificadas, enfermería domiciliaria premium, cuidado adultos mayores VIP, geriatría guadalajara jalisco, atención médica domiciliaria exclusiva",
  image: "https://geriatriaserena.com/assets/somos.png",
  locale: "es_MX"
};

// Datos estructurados para SEO (Schema.org)
export const STRUCTURED_DATA = {
  "@context": "https://schema.org",
  "@type": "MedicalBusiness",
  "name": COMPANY_INFO.name,
  "description": "Agencia de excelencia en enfermería geriátrica y cuidados domiciliarios de élite en Guadalajara. Personal certificado con estándares hospitalarios premium, planes de cuidado VIP personalizados y supervisión médica continua.",
  "url": COMPANY_INFO.websiteUrl,
  "telephone": `+52-${COMPANY_INFO.phone.slice(0,2)}-${COMPANY_INFO.phone.slice(2,6)}-${COMPANY_INFO.phone.slice(6)}`,
  "openingHours": "Mo-Su 00:00-23:59",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Lago Ginebra 2732, Patria",
    "addressLocality": "Zapopan",
    "addressRegion": "Jalisco",
    "postalCode": "45160",
    "addressCountry": "MX"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Guadalajara Metropolitana"
  },
  "medicalSpecialty": [
    "Geriatría",
    "Enfermería Domiciliaria",
    "Cuidados Paliativos"
  ],
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": COMPANY_INFO.latitude,
    "longitude": COMPANY_INFO.longitude
  }
};
